import { cn } from "@btnet/utilities-core";

import type { IQAAnswer } from "./types";

interface IAiSearchQAProps {
    qaAnswers: Record<string, IQAAnswer>;
    /**
     * PR-A2 review (thread 1511891): when true, the answer text line-clamps
     * (3 lines) instead of clipping behind a nested scroll region the user
     * can't discover. The parent pairs this with a "Show full answer" toggle
     * that expands the reserved slot — an intentional, user-initiated layout
     * change, unlike the passive-arrival shoves D4 forbids.
     */
    clamped?: boolean;
}

export function AiSearchQA(props: IAiSearchQAProps) {
    const { qaAnswers, clamped = false } = props;
    const answers = Object.values(qaAnswers).filter(Boolean);

    if (answers.length === 0) {
        return null;
    }

    return (
        <div className="ai-search-qa" data-testid="ai-search-qa">
            {answers.map((answer) => (
                <div key={answer.source} className="ai-search-qa-card">
                    <div className="ai-search-qa-label">AI Answer</div>
                    <div
                        className={cn("ai-search-qa-text", {
                            "ai-search-qa-text--clamped": clamped,
                        })}
                        data-testid="ai-search-qa-text"
                    >
                        {answer.text}
                    </div>
                    {answer.source_title && (
                        <div className="ai-search-qa-source">Source: {answer.source_title}</div>
                    )}
                </div>
            ))}
        </div>
    );
}
